
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Main() {
  const navigate = useNavigate();
  const [flightNumber, setFlightNumber] = useState('');
  const [savedFlights] = useState([
    { id: 1, number: 'SV123', route: 'الرياض - دبي', date: '2024-01-15', passengers: 12 },
    { id: 2, number: 'MS456', route: 'جدة - القاهرة', date: '2024-01-10', passengers: 8 },
    { id: 3, number: 'EK789', route: 'الدمام - لندن', date: '2024-01-05', passengers: 15 }
  ]);

  const handleFlightSearch = () => {
    if (flightNumber.trim()) {
      navigate(`/passengers?flight=${flightNumber}`);
    }
  };

  const handleSavedFlightSelect = (flight: any) => {
    navigate(`/passengers?flight=${flight.number}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 pt-12 pb-8 px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex space-x-4 space-x-reverse">
            <button 
              onClick={() => navigate('/notifications')}
              className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
            >
              <i className="ri-notification-line text-white text-lg"></i>
            </button>
            <button 
              onClick={() => navigate('/profile')}
              className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
            >
              <i className="ri-user-line text-white text-lg"></i>
            </button>
            <button 
              onClick={() => navigate('/settings')}
              className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
            >
              <i className="ri-settings-line text-white text-lg"></i>
            </button>
          </div>
        </div>

        {/* Welcome Card */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-white">
          <h1 className="text-2xl font-bold mb-2 font-arabic">مرحباً أحمد!</h1>
          <p className="text-white/80 font-arabic">ابحث عن رحلتك وتواصل مع المسافرين الآخرين</p>
        </div>
      </div>

      {/* Flight Search Section */}
      <div className="px-6 -mt-4">
        <div className="bg-white rounded-2xl p-6 shadow-lg">
          <h2 className="text-lg font-bold text-gray-800 mb-4 font-arabic">البحث عن رحلة</h2>
          
          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                value={flightNumber}
                onChange={(e) => setFlightNumber(e.target.value)}
                placeholder="أدخل رقم الرحلة (مثال: SV123)"
                className="w-full p-4 pr-12 border border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none text-right font-arabic"
              />
              <i className="ri-flight-takeoff-line absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            </div>

            <button
              onClick={handleFlightSearch}
              className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white p-4 rounded-xl font-medium hover:shadow-lg transition-all duration-300 font-arabic"
            >
              البحث عن الركاب
            </button>
          </div>
        </div>
      </div>

      {/* Saved Flights */}
      <div className="px-6 mt-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4 font-arabic">الرحلات المحفوظة</h2>
        
        <div className="space-y-3">
          {savedFlights.map((flight) => (
            <button
              key={flight.id}
              onClick={() => handleSavedFlightSelect(flight)}
              className="w-full bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 text-right"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3 space-x-reverse">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                    <i className="ri-flight-takeoff-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-800 font-arabic">{flight.number}</h3>
                    <p className="text-gray-600 text-sm font-arabic">{flight.route}</p>
                    <p className="text-gray-500 text-xs font-arabic">{flight.date}</p>
                  </div>
                </div>
                
                <div className="text-left">
                  <div className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                    {flight.passengers} راكب
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="px-6 mt-6 mb-20">
        <h2 className="text-lg font-bold text-gray-800 mb-4 font-arabic">إجراءات سريعة</h2>
        
        <div className="grid grid-cols-2 gap-4">
          <button 
            onClick={() => navigate('/chats')}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 text-center"
          >
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-chat-3-line text-green-600 text-xl"></i>
            </div>
            <h3 className="font-medium text-gray-800 font-arabic">المحادثات</h3>
            <p className="text-gray-500 text-sm font-arabic">3 محادثات جديدة</p>
          </button>

          <button 
            onClick={() => navigate('/history')}
            className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 text-center"
          >
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-history-line text-purple-600 text-xl"></i>
            </div>
            <h3 className="font-medium text-gray-800 font-arabic">السجل</h3>
            <p className="text-gray-500 text-sm font-arabic">الرحلات السابقة</p>
          </button>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-6 py-3">
        <div className="grid grid-cols-4 gap-1">
          <button className="flex flex-col items-center py-2 text-blue-500">
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الرئيسية</span>
          </button>
          <button 
            onClick={() => navigate('/passengers')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-group-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الركاب</span>
          </button>
          <button 
            onClick={() => navigate('/chats')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-chat-3-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الرسائل</span>
          </button>
          <button 
            onClick={() => navigate('/profile')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-user-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الملف</span>
          </button>
        </div>
      </div>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}
